import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'select-container',
    templateUrl: './select-container.component.html',
    providers: []
})
export class SelectContainerComponent implements OnInit, AfterViewInit{

    @Input() id;
    @Input() name;
    @Input() label;
    @Input() default;
    @Input() size;
    @Input() invalid;
    @Input() invalidText;
    @Input() disabled;
    @Input() list;
    @Input() disableDefault;
    @ViewChild("wcselect", {read: ElementRef}) child: ElementRef;
    @Output() onChange: EventEmitter<any> = new EventEmitter();
    modelValue = "";
    @Output() modelChange:EventEmitter<any> = new EventEmitter<any>();

    @Input()
    get model() {
        return this.modelValue;
    }

    set model(val) {
        this.modelValue = val;
        this.modelChange.next(this.modelValue);
        if(this.child.nativeElement.value != val){
            this.child.nativeElement.value = val;
        }
    }

    ngAfterViewInit(): void {
        this.child.nativeElement.addEventListener("change",(event) => {
            if(!!event.target.value && event.target.value!=this.modelValue){
                this.modelValue = event.target.value;
                this.modelChange.next(this.modelValue);
                if(!!this.onChange){
                    this.onChange.emit(this.modelValue);
                }
            }
        });
    }

    ngOnInit(): void {
        this.modelValue = !!this.modelValue?this.modelValue:this.default;
        this.disabled = !!this.disabled?this.disabled:false;
        this.invalid=false;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/select-container/select-container.component.ts